import React, {useEffect} from "react";
import {useAuthStore} from "@store/AuthStore";
import {usePublicTranslations} from "@i18n/i18nUtils";

export default function AuthOverlay() {

    const {t} = usePublicTranslations();

    const visible = useAuthStore((s) => s.overlayVisible);

    useEffect(() => {
        console.log("Auth overlay is", visible ? "visible" : "hidden")
        if (!visible) return;
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = prev;
        };
    }, [visible]);

    if (!visible) return null;

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                zIndex: 99999,
                background: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                gap: 12,
            }}
        >
            <div style={{fontSize: 18, fontWeight: 600}}>{t("loading")}</div>
        </div>
    );
}
